export default __webpack_public_path__ + "static/dont-visuals-size-1428d5553030f9b8a6e6fe2273fd8828.png";